import { ServiceLocator } from '../../app/ServiceLocator';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { DeleteOAuthCredentialsRequest } from '../ServerApi/requests/DeleteOAuthCredentialsRequest';
import { GetCommonUserOAuthCredentialRequest } from '../ServerApi/requests/GetCommonUserOAuthCredentialRequest';
import { GetOAuthCredentialsRequest, IGetOAuthCredentialsResult } from '../ServerApi/requests/GetOAuthCredentialsRequest';
import { TestOAuthCredentialRequest } from '../ServerApi/requests/TestOAuthCredentialRequest';
import { IOAuthCredential, IOAuthCredentialTypeInfo } from '../ServerApi/types/IOAuthCredential';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IOAuthCredentialsService } from '../services/OAuthCredentialsService';
import { ResourceQuery } from './ResourceQuery';

export class OAuthCredentialsResource {
  private listFetcher = new WebClientListResourceFetcher(GetOAuthCredentialsRequest, (result: IGetOAuthCredentialsResult) => result.credentials);

  public all(): ResourceQuery<IOAuthCredential> {
    return new ResourceQuery(this.listFetcher);
  }

  public del(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteOAuthCredentialsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public test(id: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new TestOAuthCredentialRequest(id));
  }

  public commonCredentialForDatasources(datasourceIds: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetCommonUserOAuthCredentialRequest({
      ids: datasourceIds
    }));
  }

  public canAddForConnectionType(oAuthCredentialTypeInfo: IOAuthCredentialTypeInfo): boolean {
    return ServiceLocator.get<IOAuthCredentialsService>('OAuthCredentialsService').canAddForConnectionType(oAuthCredentialTypeInfo.type);
  }
}

export const OAuthCredentials = new OAuthCredentialsResource();
